/** @format */
import { Routes, Route, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactNotifications } from "react-notifications-component";
import { ScrollToTop } from "./utils/utils";
import routes from "./routes/routes";
import { useEffect } from "react";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch(`/meta.json?t=${new Date().getTime()}`);
        if (response.ok) {
          const meta = await response.json();
          const currentVersion = localStorage.getItem("appVersion");
          if (currentVersion && currentVersion !== meta.version) {
            localStorage.clear();
            localStorage.setItem("appVersion", meta.version);
            navigate("/"); // or any other logout action, reload is also good
            window.location.reload();
          } else if (!currentVersion) {
            localStorage.setItem("appVersion", meta.version);
          }
        }
      } catch (error) {
        console.error("Error fetching meta version", error);
      }
    };
    checkVersion();
  }, [navigate]);

  return (
    <>
      <ToastContainer
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ReactNotifications />
      <ScrollToTop />
      <Routes>
        {routes.map((route) => {
          return (
            <Route
              path={route.path}
              element={route.element}
              key={`route-without-layout${route.path}`}
            />
          );
        })}
      </Routes>
    </>
  );
}

export default App;
